export default {"src":"/_next/static/media/powered-by-stripe.81fee864.svg","height":24,"width":106,"blurWidth":0,"blurHeight":0};